import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import { Button, Card, Dropdown, DropdownButton } from "react-bootstrap";
import { axiosAuth_DATA_MGMT_API, axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import { translateAPIError } from '../utils/apiUtils';
import classes from './AdminPages.module.css';
import { LoadingSpinner } from '../utils/uiUtils';


const RefDataAdmin = () => {

  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const { t } = useTranslation(["common"]);


  const [tableList,     setTableList]     = useState([]);

  const [tableToExport, setTableToExport] = useState(null);
  const [successMsg,    setSuccessMsg]    = useState(null);
  const [errMsg,        setErrMsg]        = useState('');

  const [loading,       setLoading]       = useState(false);


  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["SystemAdminFullAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    fetchExportableTables();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchExportableTables = async () => {

    try {
      const res = await axiosAuth_PLATFORM_API.get("business-configs?name=EXPORTABLE_REF_DATA_TABLES");

      if (!res.data || (res.data.length === 0) || !res.data[0].config || (res.data[0].config.length === 0)) {
        setErrMsg("I18N_No_search_result");
      } else {

        let tmpList = [];
        for (let i=0; i<res.data[0].config.length; i++) {
          tmpList.push({ key:   res.data[0].config[i],
                         value: res.data[0].config[i] });
        }

        setTableList(tmpList);
        setErrMsg('');
      }

    } catch (error) {
      if (!error.message || (error.message !== 'IGNORE')) {
        setErrMsg(t(translateAPIError(error)));
      }
    }
  };


  const onTableSelect = (key, event) => {
    setSuccessMsg('');
    setErrMsg('');
    setTableToExport(key);
  };


  const handleTableExport = (e) => {

    setSuccessMsg(null);

    if (!tableToExport || tableToExport.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_ref_table_to_export"));
      return;
    }

    setLoading(true);

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("ref-data/" + tableToExport);

        resolve(res.data);

        if (res.status === 200) {

          if (!res.data || (res.data.length === 0)) {
            setSuccessMsg({msg: t("I18N_No_data"), objName: null});
            setLoading(false);
            return;
          }

          // Prepare header fields
          let headers = Object.keys(res.data[0]);

          // Prepare data
          let csvData = [];
          csvData.push(headers);

          for (let i=0; i<res.data.length; i++) {
            let row=[];
            for (let j=0; j<headers.length; j++) {
              row.push(res.data[i][headers[j]]);
            }
            csvData.push(row);
          }

          let currentDate = new Date();
          let fileName = tableToExport + "_" + currentDate.toISOString().split("T")[0] + "_" +
                   currentDate.toLocaleTimeString().replaceAll(':','-').replaceAll(' ','');

          downloadBlob(arrayToCsv(csvData), fileName, 'text/csv;charset=utf-8;')

          setSuccessMsg({msg: t("I18N_Export_success_to_file"), objName: fileName + ".csv"});
        }

        setLoading(false);
        setErrMsg('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
        setLoading(false);
      }
    });

  }


  // https://stackoverflow.com/questions/14964035/how-to-export-javascript-array-info-to-csv-on-client-side/63744993#63744993
  // Search for: A minimalistic yet feature-complete solution :)

  function arrayToCsv(data){
    return data.map(row =>
      row
      .map(String)  // convert every value to String
      .map(v => v.replaceAll('"', '""'))  // escape double quotes
      .map(v => `"${v}"`)  // quote it
      .join(',')  // comma-separated
    ).join('\r\n');  // rows starting on new lines
  }

  function downloadBlob(content, filename, contentType) {
    // Create a blob
    var blob = new Blob([content], { type: contentType });
    var url = URL.createObjectURL(blob);

    // Create a link to download it
    var pom = document.createElement('a');
    pom.href = url;
    pom.setAttribute('download', filename);
    pom.click();
  }


  // ----- BEGIN UI -----

  return (
    <Fragment>
      <Card className='aaa' style={{border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)', padding:'20px 40px 20px 40px', maxWidth:'2500px', height:'850px', width:'100%'}}>
        <div style={{ display: 'flex' }}>
          <span className={classes.admin_pages__page_title}>
            {t("I18N_Reference_Data_Mgmt")}
          </span>

        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Ref_data_table")}
            </span>
          </div>
        </div>

        <div style={{ display: 'flex', marginTop:'10px' }}>

          <span>
            <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
              title={tableToExport ? tableToExport : t("I18N_ERR_Need_ref_table") }
              style={{ width: '180px' }}
              onSelect={onTableSelect}>
              {tableList.map((item, index) => {
                return (
                  <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                    { item.value }
                  </Dropdown.Item>
                );
              })}
            </DropdownButton>
          </span>

          <span style={{ marginLeft:'13px', marginTop:'3px' }}>
            <Button size="tiny" variant="outline-secondary" className="mb-3"
              style={{ float: 'left' }}
              onClick={handleTableExport}>
              {t("I18N_Export")}
            </Button>
          </span>
        </div>

        <div style={{ marginTop:'10px' }}>
          { errMsg ?
              <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                {errMsg}
              </span>
            : successMsg ?
              <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(0,150,0)', verticalAlign:'top'}}>
                {successMsg.msg} <b><i>{successMsg.objName}</i></b>
              </span>
            : null
          }
        </div>

        <LoadingSpinner loading={loading} />

      </Card>

    </Fragment>
  );
}

export default RefDataAdmin;
